<template>
    <jackpot-list :load="load" />
</template>
<script>
import jackpotService from "../../../services/jackpot.service";

import JackpotList from "../../common/jackpot-list.vue";

export default {
    name: "client-jackpots",
    components: { JackpotList },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    methods: {
        async load(filter) {
            return await jackpotService.getJackpots(this.clientId, filter);
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/jackpots.vue